import { render, staticRenderFns } from "./winningBidAnnouncement.vue?vue&type=template&id=afe61964&scoped=true"
import script from "./winningBidAnnouncement.vue?vue&type=script&lang=js"
export * from "./winningBidAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./winningBidAnnouncement.vue?vue&type=style&index=0&id=afe61964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe61964",
  null
  
)

export default component.exports